import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Form, Field } from "redux-form";
import { Link } from "react-router";

import LogoWithoutLabel from "../../../assets/images/logo-without-label.png";
import Message from "../../../common/components/message/message";
import Loading from "../../../common/components/ui/loading/loading";
import Button from "../../../common/components/ui/button/button";

import types from "../authTypes";
import { restorePassword, verifyTokenRecoveryPassword } from "../authActions";
import { setLoading } from "../../../helpers/redux";
import { InputLabel } from "../../../common/components/form/fields";
import { FORM_RULES } from "../../../helpers/validations";

class RestorePassword extends Component {
    constructor(props) {
        super(props);
        this.props.setLoading(types.AUTH_LOADING, true);
    }
    onSubmit = values => {
        const newValues = {
            ...values,
            token: this.props.router.params.token
        };
        this.props.setLoading(types.AUTH_LOADING, true);
        this.props.restorePassword(newValues, this.props.router);
    };

    componentWillMount() {
        this.props.verifyTokenRecoveryPassword(this.props.router.params.token, this.props.router);
    }

    renderBody = () => {
        const { handleSubmit } = this.props;
        if (new RegExp("^4", "i").test(this.props.verifyToken.status_code)) {
            return (
                <div>
                    <div className="restorePassword__header-box">
                        <div className="margin-top-small ">
                            <p className="restorePassword__header-box--title ">Oooops!</p>
                        </div>
                        <div className="margin-top-small ">
                            <img src={LogoWithoutLabel} className="restorePassword__header-box--img" alt="Logo" />
                        </div>
                    </div>
                    <div className="restorePassword__body--error">
                        <p>{this.props.verifyToken.content.message}</p>
                    </div>
                    <div className="restorePassword__body--button">
                        <Link to="/">
                            <Button
                                text="Voltar"
                                type="submit"
                                style={{ width: "80%", padding: 5, marginTop: 15 }}
                                rounded
                                radius={10}
                                buttonType="primary"
                            />
                        </Link>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="restorePassword__header-box">
                        <div className="margin-top-small ">
                            <p className="restorePassword__header-box--title ">Nova senha</p>
                        </div>
                        <div className="margin-top-small ">
                            <img src={LogoWithoutLabel} className="restorePassword__header-box--img" alt="Logo" />
                        </div>
                    </div>
                    <div className="restorePassword__body">
                        <p>Para criar sua nova senha, basta inseri-lá nos campos abaixo.</p>
                    </div>
                    <Form
                        className="form restorePassword__form-box"
                        role="form"
                        onSubmit={handleSubmit(this.onSubmit)}
                        noValidate
                    >
                        <div className="form__body">
                            <Field
                                inputClass="input--default"
                                icon="icon-email"
                                iconStyle={{fontSize: 20, paddingBottom: 11, paddingTop: 11}}
                                component={InputLabel}
                                style={{ textAlign: "left", fontSize: "1.6rem"}}
                                inputStyle={{ fontSize: "1.6rem", padding: 20, borderRadius: "1rem" }}
                                type="password"
                                name="password"
                                placeholder="Nova senha"
                                cols="12 12 12 12"
                                validate={[FORM_RULES.required]}
                            />
                            <Field
                                inputClass="input--default"
                                icon="fa fa-lock"
                                component={InputLabel}
                                style={{ textAlign: "left", fontSize: "1.6rem",  paddingBottom: "0.6rem"}}
                                inputStyle={{ fontSize: "1.6rem", padding: 20, borderRadius: "1rem" ,}}
                                type="password"
                                name="confirm_password"
                                placeholder="Confirmação da senha"
                                cols="12 12 12 12"
                                validate={[FORM_RULES.required]}
                            />
                        </div>
                        <div>
                            <Button
                                text="Enviar"
                                type="submit"
                                style={{ width: "92%", padding: 5 }}
                                rounded
                                radius={10}
                                buttonType="primary"
                            />
                        </div>
                    </Form>
                </div>
            );
        }
    };

    render() {
        if (this.props.loading) {
            return (
                <div>
                    <Loading isVisible={this.props.loading} />
                    <Message />
                </div>

            ) 
        }
        // this.props.setLoading(types.AUTH_LOADING, false);
        return (
            <section className="restorePassword">
                <div className="restorePassword__box padding-bottom-medium">
                    {this.renderBody()}
                </div>
                <Message />
                <Loading isVisible={this.props.loading} />
            </section>
        );
    }
}

RestorePassword = reduxForm({ form: "registerForm" })(RestorePassword);

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        verifyToken: state.auth.verifyToken,
        loading: state.auth.loading
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({ restorePassword, verifyTokenRecoveryPassword, setLoading }, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RestorePassword);
